
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DetailDrinksScreens from './detailDrinks'

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [type, setType] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);



    
          useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                    }
                });
          }, [menus]);
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
            setShowSpecials(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                     <div
                        style={{
                            paddingHorizontal: 20,
                            flexDirection: 'row',
                            flex: 1,
                        }}>
                        <div style={{width: '80%'}}>
                            <img
                            src={require('./assets/title.png')}
                            style={{
                                marginTop: 20,
                                width: '70%',
                                height: 90,
                                objectFit: 'contain',
                                alignSelf: 'center',
                                position: 'relative',
                                zIndex: 1,
                            }}
                            />
                            
                            <div>
                                <img
                                src={
                                    langEng
                                    ? require('./assets/text.png')
                                    : require('./assets/text.png')
                                }
                                style={{
                                    marginTop: 20,
                                    width: '70%',
                                    height: 650,
                                    objectFit: 'contain',

                                    alignSelf: 'center',
                                    position: 'relative',
                                    zIndex: 1,
                                }}
                                />
                            </div>
                        </div>
                        <div style={{width: '20%'}}>
                            <img
                            src={require('./assets/leftveg.png')}
                            style={{
                                objectFit: 'contain',
                                position: 'absolute',
                                top: 20,
                                right: -50,
                                width: 250,
                                height: 900,
                            }}
                            />
                        </div>
                        </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                 {showDrinks && <DetailDrinksScreens setshowCategories={setShowDrinks} type={type} goBack={setShowDrinks}  goHome={setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;